module.exports = __webpack_public_path__ + "static/media/recova-image.facbc15e.jpg";